module.exports = __webpack_public_path__ + "341709bb806656dff1c4fb867d368505.svg";